<mat-grid-list
  cdkDropListGroup
  snPlayerGroup="cameraGrid"
  (snPlayerGroupInit)="onPlayerGroupInit($event)"
  [cols]="screenOrientation === 'portrait' ? rows : cols"
  rowHeight="fit"
  gutterSize="0px"
>
  <mat-grid-tile
    *ngFor="let camera of displayedCameras; trackBy: trackCamera; let index = index"
    [class.empty]="!camera?.isLive && !camera?.isAxonCamera"
  >
    <ng-template [ngIf]="camera?.isLive || camera?.isAxonCamera" [ngIfElse]="empty">
      <div
        cdkDropList
        [cdkDropListData]="index"
        (cdkDropListDropped)="onDragDropped()"
        (cdkDropListEntered)="onDragEntered($event)"
      >
        <div class="item" cdkDrag [cdkDragData]="index">
          <div class="camera-player">
            <div class="camera-desc fs-text-truncate" cdkDragHandle>
              <sn-icon>drag_indicator</sn-icon>
            </div>
            <ng-container *ngIf="bulkSearch; else defaultTmpl">
              <sn-camera-stream-view
                #stream
                *ngIf="!camera.isAxonCamera"
                [class.bulkSearchCam]="bulkSearch && !camera.isFullscreen"
                [camera]="camera"
                [controls]="true"
                [timelineTime]="camTime"
                [date]="date"
                [autoplay]="autoplay"
                [allowTimeout]="allowTimeout"
                [hoverActions]="true"
                [actions]="false"
                [alwaysOn]="bulkSearch"
                [bulkSearch]="bulkSearch"
                [isGridCam]="true"
                [timelineHeight]="56"
                (streamPlay)="onCameraStreamPlay($event, camera)"
                (streamPause)="onCameraStreamPause(camera)"
                (streamStop)="onCameraStreamStop(camera)"
                (timeline)="onTimeline($event)"
                (fullscreen)="onFullscreen($event, camera)"
                (playbackReady)="onPlaybackSeek($event)"
                (currentTimelineTime)="timestampTime = $event"
              >
              </sn-camera-stream-view>
              <fs-axon-livestream-iframe
                class="axonLiveStream"
                *ngIf="camera.isAxonCamera"
                [device]="camera.axonDevice"
                [isDocked]="false"
              ></fs-axon-livestream-iframe>
            </ng-container>
            <ng-template #defaultTmpl>
              <sn-camera-stream-view
                #stream
                *ngIf="!camera.isAxonCamera"
                [camera]="camera"
                [controls]="true"
                [autoplay]="autoplay"
                [allowTimeout]="allowTimeout"
                [hoverActions]="true"
                [isGridCam]="true"
                [actions]="false"
                (streamPlay)="onCameraStreamPlay($event, camera)"
                (streamPause)="onCameraStreamPause(camera)"
                (streamStop)="onCameraStreamStop(camera)"
              >
              </sn-camera-stream-view>
              <fs-axon-livestream-iframe
                class="axonLiveStream"
                *ngIf="camera.isAxonCamera"
                [device]="camera.axonDevice"
                [isDocked]="false"
              ></fs-axon-livestream-iframe>
            </ng-template>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #empty>
      <div class="item empty">{{ index + 1 }}</div>
    </ng-template>
  </mat-grid-tile>
</mat-grid-list>
<div *ngIf="!isSessionActive" class="gridSessionEnded">
  <p>{{ 'cameras.grid.sessionExpired' | t }}</p>
  <button mat-flat-button color="accent" (click)="reinitialize()">{{ 'cameras.grid.restartGrid' | t }}</button>
</div>

<div class="controls" *ngIf="!hideBottom">
  <div class="bulkTimelineContainer" *ngIf="bulkSearch">
    <fs-timeline
      #timelineRef
      class="videoPlayerTimeline"
      *ngIf="timelineDef"
      [timelineDefinition]="timelineDef"
      [currentTime]="timelineTime"
      [disableThumnail]="true"
      [currentDate]="date"
      [fullscreen]="bulkSearch"
      (moveCursor)="moveCursor($event)"
    >
    </fs-timeline>
  </div>

  <div class="gridControls">
    <div class="timestampWrapper">
      <button mat-button (click)="prevPage()" [disabled]="!hasPrevPage()">
        <sn-icon>navigate_before</sn-icon>
        <sn-button-label>{{ 'common.previousPage' | t | uppercase }}</sn-button-label>
      </button>
      <span class="camTimeStamp" *ngIf="bulkSearch && timelineTime">
        {{ timelineTime | fsFormatDate : 'medium' }}
      </span>
    </div>
    <div class="centerButtons">
      <button mat-icon-button [matTooltip]="'common.videoPlayer.backFiveSeconds' | t" (click)="back(5)" *ngIf="bulkSearch">
        <sn-icon size="md">replay_5</sn-icon>
      </button>
      <button
        mat-icon-button
        [matTooltip]="'common.videoPlayer.backHalfSecond' | t"
        (click)="back(0.5)"
        *ngIf="bulkSearch"
      >
        <sn-icon class="fa-solid fa-backward-step" size="md"></sn-icon>
      </button>
      <button mat-icon-button [matTooltip]="'common.videoPlayer.rewind' | t" (click)="rewind()" *ngIf="bulkSearch">
        <sn-icon size="md">fast_rewind</sn-icon>
      </button>
      <button mat-icon-button [matTooltip]="'common.play' | t" (click)="playAll()" *ngIf="!isPlaying">
        <sn-icon>play_arrow</sn-icon>
      </button>
      <button mat-icon-button [matTooltip]="'common.videoPlayer.pause' | t" (click)="pauseAll()" *ngIf="isPlaying">
        <sn-icon>pause</sn-icon>
      </button>
      <button mat-icon-button [matTooltip]="'common.videoPlayer.fastForward' | t" (click)="fastForward()" *ngIf="bulkSearch">
        <sn-icon size="md">fast_forward</sn-icon>
      </button>
      <span
        class="playbackRate"
        *ngIf="(isFastForwarding && playbackRate > 1) || (isRewinding && rewindSpeedFactor > 0)"
        [class.forward]="isFastForwarding"
        [class.rewind]="isRewinding"
        >x
        <ng-container *ngIf="isFastForwarding && playbackRate > 1">{{ playbackRate }}</ng-container>
        <ng-container *ngIf="isRewinding && rewindSpeedFactor > 0">{{
          rewindSpeedFactor
        }}</ng-container>
      </span>
      <button
        mat-icon-button
        [matTooltip]="'common.videoPlayer.forwardHalfSecond' | t"
        (click)="forward(0.5)"
        *ngIf="bulkSearch"
      >
        <sn-icon class="fa-solid fa-forward-step" size="md"></sn-icon>
      </button>
      <button
        mat-icon-button
        [matTooltip]="'common.videoPlayer.forwardFiveSeconds' | t"
        (click)="forward(5)"
        *ngIf="bulkSearch"
      >
        <sn-icon size="md">forward_5</sn-icon>
      </button>
      <button
        [matTooltip]="'cameras.stream.tooltips.toggleCalendar' | t"
        mat-icon-button
        [matMenuTriggerFor]="calendarMenu"
        *ngIf="bulkSearch && timelineDef"
      >
        <sn-icon fontSet="fal" fontIcon="fa-calendar-clock"></sn-icon>
      </button>
    </div>
    <button mat-button (click)="nextPage()" [disabled]="!hasNextPage()">
      <sn-button-label>{{ 'common.nextPage' | t | uppercase }}</sn-button-label>
      <sn-icon>navigate_next</sn-icon>
    </button>

    <mat-menu #calendarMenu="matMenu" (click)="$event.stopPropagation()">
      <div matMenuContent class="calendarWrapper" (click)="$event.stopPropagation()">
        <mat-calendar
          *ngIf="timelineDef"
          class="calendar availability"
          #calendar
          (selectedChange)="onDateChange()"
          [(selected)]="date"
          [minDate]="minDate"
          [maxDate]="maxDate"
        ></mat-calendar>
      </div>
    </mat-menu>
  </div>
</div>
